export enum ExportExtent {
    all = "all",
    selected = "selected",
    searchResult = "searchResult"
}